export const regex = /^\d+(\.\d*)?%?$/;
